import React, { useContext, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import Slider from 'react-slick';
import classNames from 'classnames';
import { ThemeContext } from '@forma/forma-ui-kit';
import TeamRequestForm from '../TeamRequestForm';

import styles from './team-slider.module.css';
import { ReactSVG } from 'react-svg';

const TeamSlider = ({ items, onSubmit, isSendSuccess, isSendError }) => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';

  if (!items) return null;

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {t('team')}
      </div>
      <div className={styles.slider}>
        {!isPhone && (
          <button className={classNames(styles.sliderButton, styles.prev)} onClick={() => ref?.current?.slickPrev()}>
            <ReactSVG src="/icons/chevron-left.svg" alt="Prev" wrapper="span" />
          </button>
        )}
        <Slider
          arrows={false}
          infinite={false}
          dots={false}
          slidesToShow={4}
          responsive={[
            {
              breakpoint: 1025,
              settings: { slidesToShow: 3 }
            },
            {
              breakpoint: 800,
              settings: { slidesToShow: 2 }
            },
            {
              breakpoint: 575,
              settings: { slidesToShow: 1.2 }
            },
          ]}
          ref={ref}
        >
          {items.map(({ image, name, position, description }, index) => (
            <div className={styles.item} key={index}>
              <img className={styles.itemImage} src={image} alt={name} />
              <div className={styles.itemName}>{name}</div>
              <div className={styles.itemPosition}>{position}</div>
              <div className={styles.itemDescription} dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          ))}
          {onSubmit && (
            <div className={styles.item}>
              <img className={styles.itemImage} src="/images/team/placeholder.webp" alt="" />
              <div className={styles.itemQuestion}>Возможно это ты?</div>
            </div>
          )}
        </Slider>
        {!isPhone && (
          <button className={classNames(styles.sliderButton, styles.next)} onClick={() => ref?.current?.slickNext()}>
            <ReactSVG src="/icons/chevron-right.svg" alt="Next" wrapper="span" />
          </button>
        )}
      </div>

      {onSubmit && (
        <TeamRequestForm onSubmit={onSubmit} isSendSuccess={isSendSuccess} isSendError={isSendError} />
      )}
    </div>
  );
};

export default TeamSlider;
